var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("figure", { staticClass: "trend" }, [
    _c("ins", [_vm._v(_vm._s(_vm.formatNumber(_vm.data[1])))]),
    _vm._v(" "),
    _c(
      "span",
      { class: _vm.trend },
      [
        _c("Icon", { staticClass: "icon", attrs: { name: "arrow" } }),
        _vm._v(" "),
        _vm.percent !== undefined
          ? [
              !_vm.percent ? _c("span", [_vm._v("0%")]) : _vm._e(),
              _vm._v(" "),
              _vm.percent < 0
                ? _c("span", [
                    _vm._v(_vm._s(_vm.formatNumber(-_vm.percent)) + "%")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.percent > 0
                ? _c("span", [
                    _vm._v(_vm._s(_vm.formatNumber(_vm.percent)) + "%")
                  ])
                : _vm._e()
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16b58649", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16b58649","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/helpers/components/charts/Trend.vue
// module id = null
// module chunks = 